import React from 'react'
import { Icon, Message, MessageContent, MessageHeader } from 'semantic-ui-react'

export const EmptyBox = ({ text = "No Data Found" }) => (
    <Message
        icon="inbox"
        header={text}
    />
)

export const LoaderDataBox = () => <Message icon>
    <Icon name="circle notched" loading />
    <MessageContent>
        <MessageHeader>Just one second</MessageHeader>
        We are fetching that content for you.
    </MessageContent>
</Message>